import {ADD_SKILL, DELETE_SKILL, UPDATE_SKILL, SET_SKILL} from "../constants";

const initialState = [];

export const skillReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_SKILL: {
            state = [...payload];
            return state;
        }
        case ADD_SKILL: {
            state = [{...payload, course_count:[]}, ...state];
            return state;
        }
        case UPDATE_SKILL: {
            let temp = [...state];
            let index = temp.findIndex(skill => skill.id === payload.id);
            if (index > -1) {
                temp[index] = payload;
            }
            return temp;
        }
        case DELETE_SKILL: {
            let temp = [...state];
            let index = temp.findIndex(skill => skill.id === payload);
            if (index > -1) {
                temp.splice(index, 1);
            }
            return temp;
        }
        default: {
            return state
        }
    }
};